/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusPaymentVoucherDto
 */
export interface NovitusPaymentVoucherDto {
    /**
     * Nazwa formy płatności bonem
     * @type {string}
     * @memberof NovitusPaymentVoucherDto
     */
    name: string;
    /**
     * Wartość płatności bonem jako string numeryczny
     * @type {string}
     * @memberof NovitusPaymentVoucherDto
     */
    value: string;
}

/**
 * Check if a given object implements the NovitusPaymentVoucherDto interface.
 */
export function instanceOfNovitusPaymentVoucherDto(value: object): value is NovitusPaymentVoucherDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusPaymentVoucherDtoFromJSON(json: any): NovitusPaymentVoucherDto {
    return NovitusPaymentVoucherDtoFromJSONTyped(json, false);
}

export function NovitusPaymentVoucherDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPaymentVoucherDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function NovitusPaymentVoucherDtoToJSON(value?: NovitusPaymentVoucherDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

